<template>
    <div>
        <div class="button-area">
            <!--            <Button @click="save()"-->
            <!--                    :loading="saveLoading"-->
            <!--                    type="primary"-->
            <!--                    class="button-right-left">保存-->
            <!--            </Button>-->
            <Button @click="back()" class="button-right">返回</Button>
        </div>
        <div class="form-area">
            <Form style="width: 500px"
                  :model="model"
                  :label-width="110"
                  label-position="left"
                  inline>
                <FormItem :class="{ 'model-hidden': true }" label="文本框">
                    <Input v-model="model.id" type="text"></Input>
                </FormItem>
                <FormItem label="用户姓名">
                    <Input
                            readonly
                            v-model="model.name"
                            style="width: 320px"
                            type="text"
                    ></Input>
                </FormItem>
                <FormItem label="手机号">
                    <Input
                            readonly
                            v-model="model.phone"
                            style="width: 320px"
                            type="text"
                    ></Input>
                </FormItem>
                <FormItem label="身份证">
                    <Input
                            readonly
                            v-model="model.sfz"
                            style="width: 320px"
                            type="text"
                    ></Input>
                </FormItem>
                <!-- <FormItem label="头像">
                    <img style="width: 200px;height: 160px" :src="model.pic" alt=""/>
                </FormItem>
                <br> -->
                <FormItem label="身份证正面照片">
                  <previewImg style="width: 200px;height: 160px" v-if="model.idCardFrontPic.url" :src="model.idCardFrontPic.url"
                              alt=""/>
                  <img style="width: 200px;height: 160px" v-else :src="require('../../../../assets/noPic.jpg')" alt=""/>
                </FormItem>
                <br>
                <FormItem label="身份证背面照片">
                  <previewImg style="width: 200px;height: 160px" v-if="model.idCardBackPic.url" :src="model.idCardBackPic.url"
                              alt=""/>
                  <img style="width: 200px;height: 160px"  :src="require('../../../../assets/noPic.jpg')" alt="" v-else/>
                </FormItem>
                <FormItem label="申请认证时间">
                    <Input
                            readonly
                            v-model="model.createTime"
                            style="width: 320px"
                            type="text"
                    ></Input>
                </FormItem>
            </Form>
        </div>
        <div style="display: flex; justify-content: center; align-items: center">                      
            <Button
                    @click="pass"
                    type="primary"
                    class="button-right"
            >审核通过
            </Button>
                                    
            <Button
                    @click="regect"
                    type="warning"
                    class="button-right"
            >拒绝通过
            </Button>
                
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js'
    import previewImg from '@/components/previewImg'

    export default {
        name: 'tqtUserForm',
      components: {previewImg },

        data () {
            return {
                //ID
                id: null,
                saveLoading: false,
                //表单参数
                model: {
                    // id: null,
                    name: null,
                    phone: null,
                    // password: null,
                    sfz: null,
                    // email: null,
                    pic: null,
                    // isrealauth: null,
                    idCardFrontPic: null,
                    idCardBackPic: '',
                    // sex: null,
                    createtime: null,
                    userToCompany: null,
                },
            }
        },
        mounted () {
            if (
                    typeof this.$route.query.id !== 'undefined' &&
                    this.$route.query.id !== null &&
                    this.$route.query.id !== ''
            ) {
                this.id = this.$route.query.id
                //ID存在渲染表单
                this.initForm()
            }
        },
        methods: {
            formatTime (UTCDateString) {
                if (!UTCDateString) {
                    return '-'
                }

                function formatFunc (str) {
                    //格式化显示
                    return str > 9 ? str : '0' + str
                }

                var date2 = new Date(UTCDateString) //这步是关键
                var year = date2.getFullYear()
                var mon = formatFunc(date2.getMonth() + 1)
                var day = formatFunc(date2.getDate())
                var hour = date2.getHours()
                var min = formatFunc(date2.getMinutes())
                var second = date2.getSeconds()
                var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + second
                // var dateStr = year + '-' + mon + '-' + day
                return dateStr
            },
            //保存
            save () {
                if (this.id) {
                    this.update()
                } else {
                    this.create()
                }
            },

            // 审核通过
            pass () {
                this.$http
                        .post('/api/realauth/examine', {
                            status: 2,
                            idCardBackPic: this.model.idCardBackPic.uri,
                            name: this.model.name,
                            idCardFrontPic: this.model.idCardFrontPic.uri,
                            sfz: this.model.sfz,
                            userid: this.model.id,
                        })
                        .then(() => {
                            this.$Notice.success({
                                title: '审核通过'
                            })
                            this.back()
                        })
            },

            //拒绝通过
            regect () {
                this.$prompt('请输入拒绝原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '拒绝原因不能为空'
                }).then(({ value }) => {
                    this.$http.post('/api/realauth/examine', {
                            status: 1,
                            idCardBackPic: this.model.idCardBackPic.uri,
                            name: this.model.name,
                            idCardFrontPic: this.model.idCardFrontPic.uri,
                            sfz: this.model.sfz,
                            userid: this.model.id,
                            resason: value,
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '已拒绝!'
                        });
                        this.$router.push({
                            name: 'tqt_user'
                        })
                    }).catch(res => {
                        this.$message({
                            type: 'warning',
                            message: '拒绝已取消！'
                        });
                    });
                })
            },
            //拒绝通过
            // regect () {
            //     this.$http
            //             .post('/api/realauth/examine', {
            //                 status: 1,
            //                 idCardBackPic: this.model.idCardBackPic.uri,
            //                 name: this.model.name,
            //                 idCardFrontPic: this.model.idCardFrontPic.uri,
            //                 sfz: this.model.sfz,
            //                 userid: this.model.id,
            //             })
            //             .then(() => {
            //                 this.$Notice.success({
            //                     title: '已拒绝'
            //                 })
            //                 this.back()
            //             })
            // },
            create () {
                let _this = this
                _this.saveLoading = true
                util.http
                        .get('/api/user/details', this.model, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '保存成功!',
                            })
                            _this.back()
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '保存失败!',
                            })
                            _this.saveLoading = false
                            console.log(error)
                        })
            },

            update () {
                let _this = this
                _this.saveLoading = true
                util.http
                        .get('/api/user/details', this.model, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '更新成功!',
                            })
                            _this.back()
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '更新失败!',
                            })
                            _this.saveLoading = false
                            console.log(error)
                        })
            },
            //渲染表单
            initForm () {
                let _this = this
                util.http.get('/api/user/details/' + this.id, {
                    params: {},
                }).then(function (response) {
                    let obj = response.data
                    _this.model.id = obj.realAuth.userid
                    _this.model.name = obj.realAuth.name
                    _this.model.phone = obj.baseInfo.phone
                    _this.model.sfz = obj.realAuth.sfz
                    _this.model.pic = obj.baseInfo.pic
                    _this.model.idCardFrontPic = obj.realAuth.idCardFrontPic
                    _this.model.idCardBackPic = obj.realAuth.idCardBackPic
                    _this.model.createtime = obj.realAuth.createtime
                    _this.model.createTime = _this.formatTime(obj.realAuth.createtime)
                }).catch(function (error) {
                    _this.$Notice.error({
                        title: '获取表单失败!',
                    })
                    console.log(error)
                })
            },

            //返回,需要自定义配置路由
            back () {
                let _this = this
                let tagName = _this.$route.name
                _this.$store.commit('removeTag', tagName)
                _this.$store.commit('closePage', tagName)
                _this.$router.push({
                    name: 'tqt_user',
                })
            },
        },
    }
</script>

<style scoped>
    .button-area {
        display: flex;
        justify-content: flex-end;
    }

    .button-right-left {
        margin-right: 15px;
    }

    .button-right {
        margin-right: 55px;
    }

    .form-area {
        margin-top: 40px;
        display: flex;
        justify-content: center;
    }

    .form-flex {
        display: flex;
        justify-content: space-between;
    }

    .model-hidden {
        display: none;
    }
</style>
